"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandledError = void 0;
class HandledError extends Error {
}
exports.HandledError = HandledError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGFuZGxlZC5lcnJvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9oYW5kbGVkLmVycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLE1BQWEsWUFBYSxTQUFRLEtBQUs7Q0FBRztBQUExQyxvQ0FBMEMifQ==